import { Dropdown } from 'formik-semantic-ui'
import pacsJson from './data/pacs.json'
import modalityOptionsJson from './data/modalityOptions.json'
import studyDescriptionsJson from './data/studyDescriptions.json'
import aeTitles from './data/aeTitles.json'
import pacsLabels from './data/pacsLabels.json'

export const pacsLabel = (sbu, id) =>
  (pacsLabels[sbu] && pacsLabels[sbu][id]) || id

const dropdownHeader = title => ({
  component: Dropdown.Header,
  icon: 'group',
  disabled: true,
  content: title,
  key: title
})

// Semantic UI Dropdown.Item props
const basicDropdownItem = id => ({ text: id, value: id, key: id })

const institutionDropdownItem = (category, id, sbu) => ({
  value: JSON.stringify({
    aeTitle: aeTitles[sbu][category],
    hospital: id
  }),
  key: id,
  text: pacsLabel(sbu, id),
  icon: 'building',
  style: { marginLeft: '16px' }
})

const modalityTypesDropdownItem = ({ code, description }) => ({
  label: code,
  text: description,
  value: code
})

const studyDescriptionsDropdownItem = id => ({
  ...basicDropdownItem(id),
  text: id
})

export const requestingInstitutionsForSbu = sbu =>
  sbu
    ? Object.entries(pacsJson[sbu])
        .map(([sectionHeader, choices]) => {
          return [
            ...(sectionHeader === '' || sbu === 'Apex Radiology (WA)'
              ? []
              : [dropdownHeader(sectionHeader)]),
            ...choices.map(id =>
              institutionDropdownItem(sectionHeader, id, sbu)
            )
          ]
        })
        .flat()
    : []

export const modalityOptions = sbu => {
  return Object.keys(studyDescriptionsJson[sbu]).map(id =>
    modalityTypesDropdownItem({
      code: id,
      description:
        modalityOptionsJson.find(mod => mod.code === id)?.description || id
    })
  )
}

export const studyDescriptionOptions = (sbu, modalityCode) => {
  const studyDescriptionIds = studyDescriptionsJson[sbu][modalityCode] || []

  // auto select a single study description option
  const selected = studyDescriptionIds.length === 1
  return studyDescriptionIds.map(id =>
    studyDescriptionsDropdownItem(id, selected)
  )
}

export const validateProviderNumber = providerNumber => {
  /* https://clearwater.com.au/code/provider */

  const validStem = /[0-9]{6}/
  const validLocation1 = /[a-z0-9]/i
  const validLocation2 = /[^iosz]/i
  const validCheck = /[abfhjkltwxy]/i

  // Practice Location Value
  const plv = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    J: 18,
    K: 19,
    L: 20,
    M: 21,
    N: 22,
    P: 23,
    Q: 24,
    R: 25,
    T: 26,
    U: 27,
    V: 28,
    W: 29,
    X: 30,
    Y: 31
  }

  const remainderCheckMapping = {
    0: 'Y',
    6: 'J',
    1: 'X',
    7: 'H',
    2: 'W',
    8: 'F',
    3: 'T',
    9: 'B',
    4: 'L',
    10: 'A',
    5: 'K'
  }

  const digits = providerNumber.split('')
  if (digits.length !== 8) return false

  const stem = digits.slice(0, 6)
  const location = digits.slice(6, 7)[0]
  const check = digits.slice(7, 8)[0]

  if (
    validStem.test(stem.join('')) &&
    validLocation1.test(location) &&
    validLocation2.test(location) &&
    validCheck.test(check)
  ) {
    // check the correctness of the check digit
    const digits = stem.map(d => +d)
    const remainder =
      (digits[0] * 3 +
        digits[1] * 5 +
        digits[2] * 8 +
        digits[3] * 4 +
        digits[4] * 2 +
        digits[5] * 1 +
        plv[location] * 6) %
      11

    return check === remainderCheckMapping[remainder]
  }

  return false

  //  R = ((digit 1x3) + (digit 2x5) + (digit 3x8) + (digit 4x4) + (digit 5x2) + (digit 6) + (PLV x 6)) % 11
}
